import { formatDate } from '@/utils'
import { DATE_PICKER_DATE_FORMAT } from '../DateRangePicker'
import { GetDateLabelProps } from './DateRangePickerInput.types'

export const getDateLabel = ({
  value,
  format = DATE_PICKER_DATE_FORMAT,
  showBlankOnNull = false,
  singleDate = false,
}: GetDateLabelProps): string => {
  const { startDate, endDate } = value
  let startValue = showBlankOnNull ? '' : format
  let endValue = showBlankOnNull ? '' : format

  if (startDate) startValue = formatDate(startDate, format)
  if (endDate) endValue = formatDate(endDate, format)

  return singleDate ? startValue : `${startValue} - ${endValue}`
}
